import { SCOPE_TYPE } from "@model";
import { useAuthContext } from "@service";

// PACS connectivity (worklist query, auto-send, MPPS) talks DIMSE directly to a
// hospital PACS, which only works where the app runs on the hospital network:
// the on-prem Offline build and local development. The cloud build cannot reach
// a private hospital network, so the feature is compiled out there. DICOM file
// generation is unaffected by this gate.
export function isPacsConnectivityEnabled(): boolean {
  return (
    process.env.REACT_APP_OFFLINE === "true" || process.env.REACT_APP_USE_LOCAL_SERVERS === "true"
  );
}

export function usePacsFeatureEnabled(): boolean {
  const { scopes } = useAuthContext();
  return scopes.includes(SCOPE_TYPE.dicom) && isPacsConnectivityEnabled();
}
